let isSupportWebp = false

function supportWebp() {
    const ele = document.createElement('canvas')
    ele.width = 1
    ele.height = 1
    return (
        ele.toDataURL &&
        ele.toDataURL('image/webp').indexOf('data:image/webp') === 0
    )
}

isSupportWebp = supportWebp()

// 基本图像处理接口
function imagePreview(value: string, width: number, height: number, type: string, viewType = '2') {
    const view = viewType || '2'
    // value = utils.replaceHttpToHttps(value)
    let imgUrl = `${value}?imageView2/${view}`
    imgUrl = imgUrl.replace(/^http(s?):/, '')
    if (width) {
        imgUrl = `${imgUrl}/w/${width}`
    }
    if (height) {
        imgUrl = `${imgUrl}/h/${height}`
    }
    if (type) {
        imgUrl = `${imgUrl}/q/100/format/${type}`
    } else {
        imgUrl = `${imgUrl}/q/100/format/jpg`
    }
    return imgUrl
}

/**
   * 判断图片是否支持webp格式，并转换
   * @param {string} value
   * @param {Number} width
   * @param {Number} height
   * @param {string} type
   */
export function viewImage(value: string, width: number, height: number, type = 'jpg') {
    let img = value
    if (value) {
        // value = utils.replaceHttpToHttps(value)
        value = value.replace(/^http(s?):/, '')
        img = imagePreview(
            value,
            width,
            height,
            isSupportWebp ? 'webp' : type

        )
    }
    return img
}

// 图片压缩,居中裁剪
export function viewImageInCenter(value: string, width: number, height: number, type: string) {
    let img = ''
    const imgType = type || 'jpg'
    if (value) {
        value = value.replace(/^http(s?):/, '')
        // value = utils.replaceHttpToHttps(value)
        if (isSupportWebp) {
            img = imagePreview(value, width, height, 'webp', '1')
        } else {
            img = imagePreview(value, width, height, type, '1')
        }
    }
    return img
}
